import "../index.css";

interface ErrorMessageProps {
  message: string;
}

export default function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <p className="error font_family_base" style={{ textAlign: "center" }}>
      <span>⛔️</span> {message}
    </p>
  );
}
